<template>
    <div v-if="currentPlan" id="dashboard-billing-view">
        <span class="dashboard-title mb-5">Billing</span>

        <div class="dashboard-boxed-container-wrapper d-flex">
            <div class="dashboard-boxed-container mr-4">
                <span class="dashboard-subtitle mb-4">Your plan</span>

                <v-row class="dashboard-text">
                    <v-col sm="3">
                        Plan
                    </v-col>
                    <v-col sm="9">
                        {{ userPlan }}
                        <span class="color-red">{{ userPlanState }}</span>
                        <span v-if="currentPlan.fastspring.subscription" class="d-flex mt-3 align-center">
                            (ID: {{ currentPlan.fastspring.subscription }})
                            <i class="material-icons ml-2" @click="copySubscriptionId" v-tippy="{theme: 'dashboard'}"
                               content="Copy ID" style="font-size: 18px; cursor: pointer;"
                            >content_copy</i>
                        </span>
                    </v-col>
                </v-row>

                <v-row v-if="currentPlan.id !== 1">
                    <v-col sm="3">
                        <span style="line-height: 1.2">Next Bill</span>
                    </v-col>
                    <v-col sm="9" v-if="!isSubscriptionCanceled">
                        <span style="line-height: 1.2">
                            Your next bill is for {{ currentPlan.fastspring.nextChargeTotalDisplay }} on
                        {{ Moment(currentPlan.fastspring.nextChargeDate).format("MMMM Do, YYYY") }}
                        </span>
                    </v-col>
                    <v-col sm="9" v-else>
                        <span style="line-height: 1.2">
                            Your subscription ends on
                        {{ Moment(currentPlan.fastspring.nextChargeDate).format("MMMM Do, YYYY") }}
                        </span>
                    </v-col>
                </v-row>

                <div class="d-flex mt-10">
                    <v-btn
                        v-if="isSubscriptionCanceled"
                        @click="uncancelSubscription()"
                        :loading="uncancelSubscriptionLoader"
                        class="color-gray rounded-xl mr-5"
                        large
                        outlined
                    >
                        Uncancel Subscription
                    </v-btn>

                    <v-btn
                        class="color-gray rounded-xl mr-5"
                        :href="currentPlan.change_payment_method_link"
                        target="_blank"
                        large
                        outlined
                        v-if="currentPlan.id !== 1"
                    >
                        Change Payment Method
                    </v-btn>

                    <v-btn class="color-gray rounded-xl" large outlined :loading="isUpgradingPlan"
                           @click="goToChangePlanView()"
                    >
                        Change plan
                    </v-btn>
                </div>
            </div>

            <div v-if="currentPlan.id !== 1 && !isSubscriptionCanceled" class="dashboard-boxed-container">
                <span class="dashboard-subtitle mb-4">Cancel Subscription</span>

                <v-row class="mb-auto">
                    <v-col class="dashboard-text">
                        <span class="color-red">DANGER:</span>
                        Your fylm.ai access will stop at the end of your current billing cycle after cancellation.
                        Afterwards, all of your files will be permanently deleted and unrecoverable.
                    </v-col>
                </v-row>

                <v-dialog
                    v-model="cancelSubscriptionDialog"
                    content-class="dashboard-dialog"
                    max-width="450px"
                    transition="fade-transition"
                >
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn v-bind="attrs" v-on="on" class="btn-danger rounded-xl mt-auto align-self-start" large outlined
                               :loading="cancelSubscriptionLoader"
                        >
                            Cancel Subscription
                        </v-btn>
                    </template>
                    <v-card>
                        <v-card-title>
                            <span>Cancel Subscription</span>
                        </v-card-title>
                        <v-card-text class="mb-5 color-gray">
                            <p class="color-gray text-left">
                                <span class="color-red">DANGER:</span>
                                Your fylm.ai access will stop at the end of your current billing cycle after cancellation.
                                Afterwards, all of your files will be permanently deleted and unrecoverable.
                            </p>
                            <p class="text-left mb-4">To confirm subscription cancellation please type:<br /> DELETE PERMANENTLY</p>
                            <input type="text" v-model="cancelSubscriptionConfirmation" required />
                        </v-card-text>
                        <v-card-actions>
                            <v-btn class="--disable mr-5" text @click="cancelSubscription()">
                                Confirm
                            </v-btn>

                            <v-btn class="--cancel" text
                                   @click="cancelSubscriptionDialog = false"
                            >
                                Close
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </div>
        </div>

        <span class="dashboard-subtitle mt-10 mb-4">Billing History</span>

        <v-row class="mb-5">
            <v-col sm="4">
                <div class="dashboard-column-title text-left ">Date</div>
            </v-col>
            <v-col sm="4">
                <div class="dashboard-column-title text-center ">Amount</div>
            </v-col>
            <v-col sm="4">
                <div class="dashboard-column-title text-center ">Action</div>
            </v-col>
        </v-row>

        <v-row v-for="(charge, index) in chargesList" :key="index" class="mb-10 align-center">
            <v-col sm="4">
                {{ Moment(charge.timestamp).format("MMMM D, YYYY") }}
            </v-col>
            <v-col sm="4" class="text-center">${{ charge.totalInPayoutCurrency }}</v-col>
            <v-col sm="4" class="text-center">
                <v-btn
                    class="color-gray rounded-xl"
                    :href="currentPlan.charges[index].invoiceUrl"
                    target="_blank"
                    large
                    outlined
                >
                    DOWNLOAD INVOICE
                </v-btn>
            </v-col>
        </v-row>


    </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";

export default {
    created() {
        this.$store.dispatch("User/fetchCurrentPlan");
    },

    data() {
        return {
            // userCounter: 0,
            // currentPlan: null,
            cancelSubscriptionDialog: false,
            cancelSubscriptionConfirmation: "",
            cancelSubscriptionLoader: false,
            uncancelSubscriptionLoader: false,
        };
    },

    computed: {
        ...mapState("User", ["account", "currentPlan"]),
        ...mapGetters("Loader", ["isUpgradingPlan"]),
        ...mapGetters("User", ["user"]),

        userPlan() {
            if (this.currentPlan.id == 1) return "Free";
            else return this.currentPlan.fastspring.display;
            // switch (this.currentPlan.id) {
            // 	case 1:
            // 		return "Free";
            // 	case 2:
            // 		return "Professional (billed monthly)";
            // 	case 3:
            // 		return "Professional";
            // 	case 4:
            // 		return "Team (billed monthly)";
            // 	case 5:
            // 		return "Team";
            // 	case 6:
            // 		return "Enterprise";

            // 	default:
            // 		null;
            // 		return null;
            // }
        },

        userPlanState() {
            switch (this.currentPlan.fastspring.state) {
                case "canceled":
                    return "[CANCELED]";
                case "overdue":
                    if (this.currentPlan.id !== 1) return "[OVERDUE]";
                    else return null;
                default:
                    return null;
            }
        },

        planQuota() {
            return (this.currentPlan.plan_quota.used_storage / this.currentPlan.plan_quota.max_storage) * 100;
        },

        // usersQuota() {
        // 	return (this.currentPlan.users.added / this.currentPlan.users.added) * 100;
        // },

        isSubscriptionCanceled() {
            return this.currentPlan.fastspring.state == "canceled" ? true : false;
        },

        chargesList() {
            if (this.currentPlan.charges) return this.currentPlan.charges.filter(charge => charge.status !== "failed");
            else return [];
        },
    },

    methods: {
        async cancelSubscription() {
            if (this.cancelSubscriptionConfirmation !== "DELETE PERMANENTLY") return;

            this.cancelSubscriptionLoader = true;
            this.cancelSubscriptionDialog = false;

            await this.$apiService.delete(`accounts/${this.account.id}/cancel-subscription`);
            let fetchCurrentPlanInterval = setInterval(async () => {
                await this.$store.dispatch("User/fetchCurrentPlan");

                if (this.currentPlan.fastspring.state == "canceled") {
                    this.cancelSubscriptionLoader = false;
                    this.$snackbar("Subscription has been cancelled.", "success");
                    clearInterval(fetchCurrentPlanInterval);
                }
            }, 3000);
        },

        async uncancelSubscription() {
            this.uncancelSubscriptionLoader = true;

            await this.$apiService.post(`accounts/${this.account.id}/uncancel-subscription`);

            let fetchCurrentPlanInterval = setInterval(async () => {
                await this.$store.dispatch("User/fetchCurrentPlan");

                if (this.currentPlan.fastspring.state !== "canceled") {
                    this.uncancelSubscriptionLoader = false;
                    clearInterval(fetchCurrentPlanInterval);
                }
            }, 3000);
        },

        goToChangePlanView() {
            this.$router.push({ name: "account.billing.changePlan" });
        },

        copySubscriptionId() {
            navigator.clipboard.writeText(this.currentPlan.fastspring.subscription);
        }
    },
};
</script>